import { Injectable, OnDestroy } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';

import * as LocationActions from './locations.actions';
import { catchError, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { LocationService } from 'services/location.service';
import { LocationInterface, LocationInterfaceWithId } from '@sk/sk-interfaces';


@Injectable()
export class LocationsEffects implements OnDestroy{
  unsubscribe = new Subject();




  queryLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationActions.queryFireStoreLocations),
      takeUntil(this.unsubscribe),
      switchMap(() => this.locationService.queryStateChangesLocations()),
      mergeMap(actions => actions),
      map(action => {
        if (action.payload.doc.exists) {
          const payload = {
            ...action.payload.doc.data() as LocationInterface,
            id: (action.payload.doc.id) ? action.payload.doc.id : null,
            exists: action.payload.doc.exists
          } as LocationInterfaceWithId;
          // FireStore Events:  'added' | 'removed' | 'modified'
          switch (action.type) {
            case 'added':
              return LocationActions.fromFireStoreAddLocation({ location: payload });
              break;
            case 'removed':
              return LocationActions.fromFireStoreRemoveLocation({ id: payload.id });
              break;
            case 'modified':
              return LocationActions.fromFireStoreModifyLocation({
                location: payload
              });
              break;
          }
        }
      }),
      catchError((error) => {
        return of(LocationActions.queryFireStoreLocationsError({
          error
        }));
      })
    )
  );


  updateLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationActions.updateLocation),
      switchMap(action => {
        return this.locationService.updateLocationById(action.changes, action.id);
      }),
      map(() => LocationActions.updateLocationSuccess({})
      ),
      catchError((error) => {
        return of(LocationActions.updateLocationsError({
          error
        }));
      })
    )
  );


  addLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationActions.addLocation),
      switchMap(action => {
        console.log('ADD', action);
        return this.locationService.addLocationByNgrx(action.location);
      }),
      map(() => LocationActions.addLocationSuccess({})),
      catchError((err: Error) => {
        console.error(err);
        if (err) {
          return of(LocationActions.addLocationError({ error: err }));
        }
      })
    )
  );

  constructor(private actions$: Actions,
              private locationService: LocationService) {
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
